import React, { useEffect } from "react";
import { Grid, TextField } from "@mui/material";
import { ExternalCommand } from "../../models/testSteps/externalCommand.ts";

interface Props {
  data: ExternalCommand;
  onChange: (updated: ExternalCommand) => void;
  setIsValid: (valid: boolean) => void;
}

const EditExternalCommandForm: React.FC<Props> = ({ data, onChange, setIsValid }) => {
  useEffect(() => {
    const isValid = data.name.trim() !== "" && data.exec !== undefined && data.exec.trim() !== "" && data.args !== undefined && checkArgs(JSON.stringify(data.args ?? "")) && data.result !== undefined;
    setIsValid(isValid);
  }, [data, setIsValid]);

  const checkArgs = (args: string) : boolean => {
    try {
        const parsed = JSON.parse(args);
        if (Array.isArray(parsed)) {
            return true;
        }
        return false;
    } catch {
        return false;
    }
  }

  const handleArgsChange = (args: string) => {
    try {
        const parsed = JSON.parse(args);
        if (Array.isArray(parsed)) {
            onChange({ ...data, args: parsed });
        }
    } catch {
    }
  }

  return (
    <Grid container spacing={2} mt={1}>
      <Grid size={12}>
        <TextField
          label="Name"
          fullWidth
          value={data.name}
          onChange={(e) => onChange({ ...data, name: e.target.value })}
        />
      </Grid>
      <Grid size={12}>
        <TextField
          label="exec"
          fullWidth
          value={data.exec}
          onChange={(e) => onChange({ ...data, exec: e.target.value })}
        />
      </Grid>
      <Grid size={12}>
        <TextField
          label="args, JSON-Array"
          multiline
          fullWidth
          value={JSON.stringify(data.args)}
          onChange={(e) => handleArgsChange(e.target.value)}
        />
      </Grid>
      <Grid size={12}>
        <TextField
          label="result"
          fullWidth
          value={data.result}
          onChange={(e) => onChange({ ...data, result: e.target.value })}
        />
      </Grid>    
      <Grid size={12}>      
        <TextField
          fullWidth
          label="Timeout (ms)"
          type="number"
          inputProps={{ step: 1 }}
          value={data.timeout}
          onChange={(e) => onChange({ ...data, timeout: parseInt(e.target.value) })}
        />
      </Grid>     
    </Grid>
  );
};

export default EditExternalCommandForm;
